module.exports = __webpack_public_path__ + "static/media/approvePayrollRequestIcon.66b9f2f7.svg";